module.exports = __webpack_public_path__ + "img/top.fe66c290.png";